import React from "react";
import { motion } from "framer-motion";

export default function Background() {
  // Define blobs with positions, size, gradient, duration
  const blobs = [
    {
      top: "10%",
      left: "5%",
      size: 72,
      gradient: "from-indigo-400 via-pink-400 to-yellow-400",
      duration: 40,
      floatDistance: 10,
    },
    {
      top: "50%",
      left: "70%",
      size: 96,
      gradient: "from-pink-300 via-purple-400 to-indigo-400",
      duration: 60,
      floatDistance: 15,
    },
    {
      top: "75%",
      left: "20%",
      size: 48,
      gradient: "from-yellow-300 via-pink-300 to-red-400",
      duration: 50,
      floatDistance: 8,
    },
  ];

  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      {blobs.map((blob, idx) => (
        <motion.div
          key={idx}
          className={`absolute rounded-full blur-3xl opacity-30 w-[${blob.size}px] h-[${blob.size}px] bg-gradient-to-tr ${blob.gradient}`}
          style={{ top: blob.top, left: blob.left }}
          animate={{
            rotate: 360,
            y: ["0%", `${blob.floatDistance}%`, "0%"], // floating up and down
          }}
          transition={{
            repeat: Infinity,
            duration: blob.duration,
            ease: "linear",
          }}
        />
      ))}
    </div>
  );
}
